import axios from 'axios';
import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import './Footer.css';
const BASE_URL = 'https://testwire.wockhardt.com';
const jwt = localStorage.getItem('jwt'); // get the JWT token from local storage

class SummaryWockhardtHistory extends React.Component 
{
  state = {showDiv: false,data: null, data1:null,responseData: null,username: '',email: '',job: '',picture: '',pictureurl: '',empcode:''};

  fetchData0 = (userId) => 
  {
    axios.get(`${BASE_URL}/api/users/${userId}?populate=*`,{headers: {Authorization: `Bearer ${jwt}`,'Content-Type': 'application/json'},})
    .then(res => {this.setState({ data0: res.data });console.log('API response user', res);})
    .catch(error => {console.error('API ERROR:', error);});
  };

  fetchData1 = () => {
    axios.get(`${BASE_URL}/api/wockhardt-summary-histories?populate=*`)
      .then(res => {
        //console.log('API response for leaders-talk-lists:', res);
        this.setState({ data: res.data });
      })
      .catch(error => {
        console.error('API error for IT Helpdesk:', error);
      });
  };

  fetchData2 = () => {
    axios.get(`${BASE_URL}/api/header-buttons?populate=*`)
      .then(res => {
        //console.log('API response for header-button:', res);
        this.setState({ data1: res.data });
      })
      .catch(error => {
        console.error('API error for header-button:', error);
      });
  };

  fetchUserData = (userId) => {
    axios.get(`${BASE_URL}/api/users/${userId}?populate=*`)
      .then(res => {
        //console.log(`API response for user data with id ${userId}:`, res);
        this.setState({ responseData: res.data });
        let username = res.data.username;
        let email = res.data.email;
        let job = res.data.job;
        let empcode = res.data.empcode;
        let picture = res.data.picture.name;
        let pictureurl = res.data.picture.url;
        this.setState({ username });
        this.setState({ email });
        this.setState({ job });
        this.setState({ empcode });
        this.setState({ picture });
        this.setState({ pictureurl });

      })
      .catch(error => {
        console.error(`API error for user data with id ${userId}:`, error);
      });
  };

  componentDidMount() {
    this.fetchData1();
    this.fetchData2();
    //const responseData = JSON.parse(localStorage.getItem("responseData"));
    let responseData = localStorage.getItem("responseData");
    this.setState({ responseData });
    let jwtDataParsed = JSON.parse(responseData);
    let id = jwtDataParsed.user.id;
    let username = jwtDataParsed.user.username;
    let email = jwtDataParsed.user.email;
    let job = jwtDataParsed.user.job;
    let empcode = jwtDataParsed.user.empcode;
    this.setState({ username });
    this.setState({ email });
    this.setState({ job });
    this.setState({ empcode });
    this.setState({ id });
    this.fetchUserData(id);
    this.fetchData0(id);
  }

    handleClick = () => {
      this.setState({
        showDiv: !this.state.showDiv
      });
    };
    
    handleGenerateQR = () => {
    const { userId} = this.state.data0;
console.log('Test')
    const payload = {data: this.state.data0};
	  console.log(JSON.stringify(payload));;
console.log('QR Data');
	  console.log(payload);
    axios.post('https://vcqr.wockhardt.com/api/v1/dostemp', payload,{
  headers: {
    'Accept': '*/*',
    'Content-Type': 'application/json',
     
  },})
      .then(response => {
        //console.log('QR generation response:', response);
        alert('Your request for eVisiting Card has been sent to Functional Head for Approval.');
      })
      .catch(error => {
        console.error('QR generation error:', error);
      });
  };

    logout = () => {
      fetch('${BASE_URL}/api/auth/local/logout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
      })
        .then(res => res.json())
        .then(response => {
          localStorage.removeItem('token');
          this.setState({
            isAuthenticated: false
          });
        })
        .catch(error => console.log(error));
    }

  render() 
  {
     if (this.state.data === null || this.state.data1 === null || this.state.responseData === null) 
     {
        return <div>Loading...</div>;
     }
    return (
      <div className='bg-silver'>
        <div className='bg-white fixed top-0 right-0 left-0 z-20 '>
          <div className="flex justify-between mb-2" > 
            <div className='mt-3 ml-5'>
              <a href='/'><img src="/Other_Images/e2logo.png" class="img-fluid w-[183px] h-[45px]" alt=""></img></a>
            </div>
            <div className='flex'>
                  <ul class="navbar-list">
                     <li>
                                        <img style={{marginTop:5, marginRight:5,cursor:'pointer', borderWidth:2, borderColor:'#0f90c0'}} src={this.state.pictureurl ? `${BASE_URL}${this.state.pictureurl}` : 'https://testwire.wockhardt.com/uploads/demouser_5fca6451b6.png?updated_at=2023-06-23T05:11:32.879Z'} alt={this.state.picture.alternativeText}  class="w-[50px] h-[50px] rounded-3xl search-toggle iq-waves-effect bg-primary text-white"  onClick={this.handleClick} />
                        {this.state.showDiv && (<div class="iq-sub-dropdown iq-user-dropdown" style={{width:'auto',right:'0', position:'absolute', background:'#ffffff', padding:0, borderRadius:'4px', boxShadow:'0px 0px 25px 0px rgba(45, 69, 95, 0.1)'}}>
                           <div class="iq-card shadow-none m-0" style={{background:'#ffffff', borderRadius:'4px',border:'none', margin:0, boxShadow:'none'}}>
                              <div class="iq-card-body p-0 " style={{padding:0}}>
                                 <div class="bg-primary p-3" style={{background:'#0f90c0'}}>
                                  <h5 class="mb-0 text-white text-xs line-height">Welcome, {this.state.username} </h5>
                                  <span class="text-white text-xs">{this.state.email}</span>
                                  <p class="text-white text-xs">{this.state.empcode}</p>
                                 </div>
                                 <a href="/profile" class="iq-sub-card iq-bg-primary-hover" style={{fontSize:'inherit', padding:5, lineHeight:'normal', borderBottom:'1px solid #0f90c0', display:'inline-block', width:'100%'}}>
                                    <div class="media align-items-center">
                                       <div class="media-body ml-3" style={{marginLeft:'1rem'}}>
                                          <h6 class="mb-0 text-xs" style={{marginBottom:'0'}}>My Profile</h6>
                                          <p class="mb-0 text-xs" style={{marginBottom:'0'}}>View personal profile details.</p>
                                       </div>
                                    </div>
                                 </a>
                                 <div class="d-inline-block w-100 text-center p-3 text-xs" style={{textAlign:'center',width:'100%', display:'inline-block'}}>
                                    <a className="iq-bg-danger iq-sign-btn" href="/generateevisitingcard" role="button" style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', float:'left', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Generate eVisitingCard<i className="ri-login-box-line ml-2"></i></a>
                                    <a class="iq-bg-danger iq-sign-btn" href="/login" role="button" style={{textAlign:'center', padding:'.375rem 1rem', borderRadius:'.25rem',border:'1px solid transparent', float:'right', display:'inline-block', background:'#0f90c0', color:'#ffffff'}} >Sign out<i class="ri-login-box-line ml-2"></i></a>
                                 </div>
                              </div>
                           </div>
                        </div>
                      )}
                     </li>
                  </ul>
                </div>
          </div>
          <div style={{ display: 'flex', justifyContent:'space-around'  }} >  
            {this.state.data1.data.map(item => (
              <div  className="mb-1">
                <div className="col-md-4" key={item.id}>
                  <a href={item.attributes.Link}><button className='text-white bg-blue mr-3 lg:w-[390px] md:w-[240px] w-[105px] rounded-md ml-3 lg:p-3 p-1 text-xs lg:text-sm'>{item.attributes.Title}</button></a>
                </div>
             </div>
            ))}
          </div>
        </div>
        <div className='bg-silver pt-32'/>              
      
        <section>  
          <div className='mb-40'>   
            {/*<p className="ml-10 text-2xl text-headings">Leaders Talk</p> */}
            <div style={{display:'inline-flex', marginLeft:'2.5rem'}}><p class="text-red text-xs text-right"><a href='/about'>Back</a></p> &nbsp; <p class="text-darkblue text-xs text-right">|</p> &nbsp; <p class="text-darkblue text-xs text-right">Summary Wockhardt History</p></div>      
            {/*<div className='lg:flex justify-around pt-3 mx-4'>
              <div style={{ display: 'flex', flexWrap: 'wrap' , justifyContent:'space-around' }}>
                {this.state.data.data.map(item => (  
                  <a href={item.attributes.Link}>              
                    <div className="col-md-4" key={item.id}>
                       <div style={{display: 'flex', flexWrap: 'wrap' , justifyContent:'space-around'}}>
                    	<div className=' pt-6'>
                            {item.attributes.Image && item.attributes.Image.data && item.attributes.Image.data.attributes && (<img class="w-[auto] h-[auto] rounded-2xl" src={`${BASE_URL}${item.attributes.Image.data.attributes.url}`} alt={item.attributes.Image.data.attributes.alternativeText}/>)}
                          </div>  
                      <div className='rounded-2xl p-4 my-4 lg:my-0' style={{marginLeft:5, marginTop:5}}>
                        <div className='flex justify-between'>
                          <p className='font-semibold m-1 text-xs text-headings'>{item.attributes.Title}</p>       
                        </div>   
                      </div> 
                      </div> 
                    </div>
                  </a>
                ))} 
              </div>
            </div>*/}
            
            
            
            <div className='justify-around pt-3 mx-4'>
              <div style={{ justifyContent:'space-around' }}> 
                {this.state.data.data.map(item => (  
                  <a href={item.attributes.Link}>              
                    <div className="col-md-12" key={item.id}>
                      <div className='bg-white rounded-2xl p-4 my-4 lg:my-0 lg:h-[auto] shadow-xl' style={{marginLeft:5, marginTop:5}}>
                        <div className="flex">    
                          <div className='pt-6' style={{textAlign:'justify'}}>
                             <div>
		                    {item.attributes.Image && item.attributes.Image.data && item.attributes.Image.data.attributes && (<img class="rounded-2xl" src={`${BASE_URL}${item.attributes.Image.data.attributes.url}`}alt={item.attributes.Image.data.attributes.alternativeText} />)}  
                            </div>
                          </div>  
                          <div className="mt-5 ml-5 text-xs" style={{textAlign:'justify'}}>
                            <p className='pt-3 m-1 text-xs'>{item.attributes.Title}</p>

                          </div> 
                        </div>   
                      </div>  
                    </div>
                  </a>
                ))} 
              </div>
            </div>
          </div>
        </section>

        {/*<section>
          <div className=" bg-darkblue mt-[75px] left-[0] bottom-[0] right-[0]">
            <div className=' text-metal lg:flex lg:justify-between lg:mx-2 lg:pl-3 mx-2 '>
              <div className=''/>
              <div>
                <h3 className='my-3 lg:mt-1 ml-2 md:pl-3 text-white'>Copyright 2022 Wockhardt All Rights Reserved.</h3>
              </div>
            </div>
          </div>
        </section>*/}
        <section>
          <div className="footer">
            <h3 className='my-3 lg:mt-1 ml-2 md:pl-3 text-xs pr-3 text-darkblue'>Copyright 2022 Wockhardt All Rights Reserved.</h3>
          </div>
        </section>
      </div>
    );
  }
}
export default SummaryWockhardtHistory;
